import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            影视专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            深度策划的影视专题内容，发现更多观影视角
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.slice(0, 3).map((item) => (
            <article
              key={item.id}
              className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-200 cursor-pointer transition-all duration-200"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => { const t = e.currentTarget; const p = t.parentElement; if (p) p.style.display = 'none'; }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>

        {cardItems.length > 3 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
            {cardItems.slice(3).map((item) => (
              <article
                key={item.id}
                className="group flex rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-200 cursor-pointer transition-all duration-200"
              >
                <div className="w-1/3 min-w-[140px] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    onError={(e) => { const t = e.currentTarget; const p = t.parentElement; if (p) p.style.display = 'none'; }}
                  />
                </div>
                <div className="p-4 flex-1 flex flex-col justify-center">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap inline-block mb-2 w-fit">
                    {item.tag}
                  </span>
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}